import './App.css';
import logo from "./images/logo.png"
import tw1 from "./images/tweet1.png"
import tw2 from "./images/tweet2.png"
import tw3 from "./images/tweet3.png"
import x from "./images/x.svg"
import tg from "./images/tg.svg"
import dex from "./images/dex.svg"

function App(){
  return (
    <div className="App">
      <Header></Header>
      <Hero></Hero>
      <Tokenomics></Tokenomics>
      <Tweets></Tweets>
      <How></How>
      <Footer></Footer>
    </div>
  );
}

function Header(){
 return(
    <div id='Header'>
      <div id='HeaderLeft'>
        <img src={logo} alt="logo"/>
        <h3>Broccoli</h3>
      </div>
      <div id='HeaderRight'>
        <a href="#Header">Home</a>
        <a href="#Tokenomics">About</a>
        <a href="#How">How to Buy</a>
        <a href="https://x.com/czhaoinu"><img src={x} alt="" /></a>
        <a href="https://t.me/Broccolicoin_portal"><img src={tg} alt="" /></a>
        <a href="https://dexscreener.com/bsc/0x5ABFfafa8016a1280178C3a750F0974315C14dC7"><img src={dex} alt="" /></a>
      </div>
    </div>
  )
}

function Hero(){
  async function copy(){
    navigator.clipboard.writeText("0x5ABFfafa8016a1280178C3a750F0974315C14dC7")
    
  }
  return(
    <div  id='Hero'>
      <div id='HeroTop'>
        <div id='HeroLeft'>
          <div id='Title'>
            <h1>The Most <h1 style={{color: "gold"}}>Safu</h1> Dog On <h1 style={{color: "gold"}}>BSC</h1></h1>
          </div>
          <h2>Meet CZ's Belgian Malinois, Broccoli — the dog has four legs and he is owned by the most safu founder in crypto.</h2>
          <button onClick={e=>window.open("https://pancakeswap.finance/?outputCurrency=0x5ABFfafa8016a1280178C3a750F0974315C14dC7")}>Buy Now</button>
        </div>
        <div id='HeroRight'>
          <img src={logo} alt="heroLogo" />
        </div>
      </div>
      <div id='HeroBottom'>
        <div id='HeroCA'>
          <span>0x5ABFfafa8016a1280178C3a750F0974315C14dC7</span>
          <button onClick={e=>copy()}>Copy</button>
        </div>
      </div>
    </div>
  )
}

function Tokenomics(){
  return(
    <div id='Tokenomics'>
      <h1>The <h1 style={{color: "gold"}}>Narrative</h1></h1>
      <span>Nobody but CZ knows the name of his dog, so we made our token contract have the ability to change the coins name and ticker on chain to the same as what CZ confirms it is! <br /> Once the dog's name has been posted by CZ, we will update the on-chain data for our CA and renounce ownership.</span>
      <div id='TokenomicsContainer'>
        <div id='TokenomicsCard'>
          <h2>🪙 Token</h2>
          <h1>BROCCOLI</h1>
          <h2>Broccoli</h2>
        </div>
        <div id='TokenomicsCard'>
          <h2>💰 Supply</h2>
          <h1>200M</h1>
          <h2>Total Supply</h2>
        </div>
        <div id='TokenomicsCard'>
          <h2>💸 Tax</h2>
          <h1>0/0</h1>
          <h2>Buy & Sell Tax</h2>
        </div>
      </div>
      
    </div>
  )
}

function Tweets(){
  return(
    <div id='Tweets'>
      <h1>The <h1 style={{color: "gold"}}>Tweets</h1></h1>
      <div id='TweetsContainer'>
        <a href="https://x.com/cz_binance/status/1889746915551543589"><img src={tw2} alt="tweet2" /></a>
        <a href="https://x.com/cz_binance/status/1395439735217164289?utm_source=chatgpt.com"><img src={tw1} alt="tweet1" /></a>
        <a href="https://x.com/cz_binance/status/1889736877801959729"><img src={tw3} alt="tweet3" /></a>
      </div>
    </div>
  )
}

function How(){
  return(
    <div id='How'>
      <h1>How to <h1 style={{color:"gold"}}>Buy</h1></h1>
      <div id='HowContainer'>
        <div id='HowCard'>
          <h2>Create Wallet</h2>
          <span>DOWNLOAD METAMASK OR YOUR WALLET OF CHOICE FROM THE APP STORE OR GOOGLE PLAY FOR FREE. DESKTOP USERS: DOWNLOAD THE GOOGLE CHROME EXTENSION BY GOING TO METAMASK.</span>
          <button onClick={e=>window.open("https://metamask.io/")}>GET METAMASK</button>
        </div>
        <div id='HowCard'>
          <h2>Get Some BNB</h2>
          <span>HAVE BNB IN YOUR WALLET TO SWITCH TO $BROCCOLI. IF YOU DON'T HAVE ANY BNB, YOU CAN BUY DIRECTLY ON METAMASK, TRANSFER FROM ANOTHER WALLET, OR BUY ON ANOTHER EXCHANGE AND SEND IT TO YOUR WALLET.</span>
          <button onClick={e=>window.open("https://binance.com/")}>BUY BNB</button>
        </div>
        <div id='HowCard'>
          <h2>Go to PancakeSwap</h2>
          <span>CONNECT TO PANCAKESWAP. CONNECT YOUR WALLET IN CHROME, PASTE THE $BROCCOLI TOKEN ADDRESS, SELECT TRADE, AND CONFIRM. WHEN METAMASK PROMPTS YOU FOR A WALLET SIGNATURE, SIGN.</span>
          <button onClick={e=>window.open("https://pancakeswap.finance/?outputCurrency=0x5ABFfafa8016a1280178C3a750F0974315C14dC7")}>BUY NOW</button>
        </div>
        <div id='HowCard'>
          <h2>Swap for BROCCOLI</h2>
          <span>SWITCH BNB FOR $BROCCOLI. WE HAVE ZERO TAXES SO YOU DON'T NEED TO WORRY ABOUT BUYING WITH A SPECIFIC SLIPPAGE. IF YOU DON'T HAVE ENOUGH BNB FOR THE GAS, YOU CAN DROP YOUR BUYING BNB AMOUNT AND SPARE FOR GAS.</span>
          <button onClick={e=>window.open("https://pancakeswap.finance/?outputCurrency=0x5ABFfafa8016a1280178C3a750F0974315C14dC7")}>SWAP NOW</button>
        </div>
      </div>
    </div>
  )
}

function Footer(){
  return(
    <div id='Footer'>
      <div id='FooterLeft'>
        <h1>BROCCOLI</h1>
      </div>
      <div id='FooterMid'>
        <span>© 2025 BROCCOLI • All rights reserved</span>
      </div>
      <div id='FooterRight'>
        <a href="https://x.com/czhaoinu"><img src={x} alt="" /></a>
        <a href="https://t.me/Broccolicoin_portal"><img src={tg} alt="" /></a>
        <a href="https://dexscreener.com/bsc/0x5ABFfafa8016a1280178C3a750F0974315C14dC7"><img src={dex} alt="" /></a>
      </div>
    </div>
  )
}

export default App;
